/**
 * Rounds the provided integer to the nearest half
 *
 * @param value {integer} required
 * @param step {integer} the nearest step you want to round to
 * @return {integer} the input value rounded to the specified step
 */
export const roundToHalf = (value, step) => {
  step || (step = 1.0)
  let inv = 1.0 / step
  return Math.round(value * inv) / inv
}
